import {
  NilStatuses,
  type PersonValuationResponse,
  type ValuationGrowthResponse,
} from '@on3/api';
import { epochDateConverter } from '@on3/ui-lib/utils/epochDateConverter';
import { NilGrowth } from 'components/Db/Profile/Nil/NilGrowth';
import Link from 'next/link';

import { NilSocialValuations } from './Nil/NilSocialValuations';
import { NilValuation } from './Nil/NilValuation/NilValuation';
import styles from './ProfileValuationModule.module.scss';

interface IProfileValuationModule {
  latestValuation?: PersonValuationResponse | null;
  valuationGrowth?: ValuationGrowthResponse | null;
}

export const ProfileValuationModule = ({
  latestValuation,
  valuationGrowth,
}: IProfileValuationModule) => {
  const lastUpdatedText =
    !!latestValuation?.lastUpdated &&
    epochDateConverter(
      latestValuation.lastUpdated,
      "'Last Updated on' MM/dd/yyyy 'at' hh:mm:ss a",
    );

  const showGrowthChart =
    latestValuation?.nilStatus === NilStatuses.Normal ||
    latestValuation?.nilStatus === NilStatuses.Final;

  return (
    <div className={styles.block}>
      <NilValuation
        groupRank={latestValuation?.groupRank}
        nilStatus={latestValuation?.nilStatus || NilStatuses.Private}
        nilValue={latestValuation?.nilValue}
        rank={latestValuation?.rank}
        rosterValue={latestValuation?.rosterValue}
        valuation={latestValuation?.valuation}
        valuationChange={latestValuation?.valuationChange}
      />
      <div className={styles.valuations}>
        <div>
          <NilSocialValuations
            groupRank={latestValuation?.groupRank}
            rank={latestValuation?.rank}
            socialValuations={latestValuation?.socialValuations}
          />
        </div>
        <div>
          {!!valuationGrowth?.list?.length && showGrowthChart && (
            <NilGrowth {...valuationGrowth} />
          )}
        </div>
        <footer>
          <p className={styles.disclaimer}>
            NIL values are updated every Wednesday.{' '}
            {!!lastUpdatedText && <span>{lastUpdatedText}</span>}
          </p>
          <Link
            className={styles.aboutLink}
            href="/nil/news/about-on3-nil-valuation-per-post-value/"
          >
            About NIL valuations
          </Link>
        </footer>
      </div>
    </div>
  );
};
